import type { DataGridContextMenuProps } from "src/components/DataGrid/useDataGridRowContextMenu.tsx";
import { useMutation } from "@tanstack/react-query";
import { download } from "@exonn/utils";
import { getExonnApi } from "src/exonn-api/exonn-api.tsx";
import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import { useSnackbar } from "src/App/App.hooks.ts";

import { ResourceEnum } from "src/constants/constants.ts";
import { useErpTranslation } from "src/system/useErpTranslation.ts";

export const useBankSepaListContextMenu = (): {
  items: DataGridContextMenuProps["items"];
  isPending: boolean;
} => {
  const { t } = useErpTranslation({
    resource: ResourceEnum.BankSepa,
    type: "layout",
  });
  const snackbar = useSnackbar();

  const { mutate, isPending } = useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      const api = getExonnApi();
      return await api.client.get(`/bank-sepa/${id}/download-xml`, {
        responseType: "blob",
      });
    },
  });
  return {
    isPending: isPending,
    items: [
      {
        key: "download",
        label: t("contextActions.download"),
        icon: <span className={"icon-20-arrow-small-down"} />,
        onSelect: (row: GridValidRowModel) => {
          mutate(
            {
              id: row.id,
            },
            {
              onSuccess: (response) => {
                if (response.data) {
                  download(response.data, `${row.id}_sepa_pain.001.xml`);
                }
              },
              onError: () => {
                snackbar.error({
                  flash: true,
                  message: t("notifications.downloadXmlFile.error"),
                });
              },
            },
          );
        },
      },
    ],
  };
};
